import React from "react";
import { useTranslation } from "react-i18next";
import {
  ActionFormDefaultTypes,
  actionFormDefaultValues,
  ActionsForm,
} from "../AtonSearchFormContainers/ActionsForm";
import {
  ConditionForm,
  conditionFormDefaults,
  ConditionFormTypes,
} from "../AtonSearchFormContainers/ConditionForm";
import {
  LocationAndResponsibilityForm,
  locationAndResponsibilityFormDefaults,
  LocationAndResponsibilityFormProps,
} from "../AtonSearchFormContainers/LocationAndResponsibilityForm";
import { GenericSearchPage } from "../GenericSearchPage";
import { useDropdownOptions } from "../hooks/useDropdownOptions";
import { WaterTrafficSignList } from "../Tables/WaterTrafficSignList";
import {
  SharedFormProps,
  WaterTrafficSignStateForm,
  waterTrafficSignStateFormDefaults,
  WaterTrafficSignStateFormTypes,
} from "../WaterTrafficSignContainers/WaterTrafficSignStateForm";

export type WaterTrafficSignTabFormData = ConditionFormTypes &
  WaterTrafficSignStateFormTypes &
  LocationAndResponsibilityFormProps &
  ActionFormDefaultTypes;

const defaultValues: WaterTrafficSignTabFormData = {
  ...waterTrafficSignStateFormDefaults,

  ...locationAndResponsibilityFormDefaults,
  ...conditionFormDefaults,

  ...actionFormDefaultValues,
};

export const WaterTrafficSignTab = ({
  isDisabled,
}: SharedFormProps): JSX.Element => {
  const { t } = useTranslation("securityDeviceSearch");
  const { searchResult } = useDropdownOptions();
  console.log(searchResult);
  const searchForms = React.useMemo(
    () => [
      {
        title: t("stateAndType"),
        children: <WaterTrafficSignStateForm isDisabled={isDisabled} />,
      },
      {
        title: t("locationAndRenponsibility"),
        children: <LocationAndResponsibilityForm isDisabled={isDisabled} />,
      },
      {
        title: t("condition"),
        children: <ConditionForm isDisabled={isDisabled} />,
      },
      {
        title: t("measures"),
        children: <ActionsForm isDisabled={isDisabled} />,
      },
    ],
    [isDisabled, t],
  );

  return (
    <GenericSearchPage<WaterTrafficSignTabFormData>
      searchContainers={searchForms}
      defaultValues={defaultValues}
      tableContent={<WaterTrafficSignList data={[]} />}
      pageTitle={t("fairwayReport:waterTrafficSign")}
      isDisabled={isDisabled}
      atonUnits={[]}
    />
  );
};
